<template>
  <div>
    <form>
      <div v-for="(item, index) in parameters" :key="item.id">
        <h2>{{ item.name }}</h2>
        <b-row>
          <b-col cols="6">
            <b-form-group label="Nombre d'événements à afficher" :label-for="'limit' + index">
              <b-form-input :id="'limit' + index" name="limit" min="1" max="20" placeholder="Nombre d'événements à afficher" type="number" v-model="parameters[index].limit"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="Indiquez le nombre de jours avant lesquels un événement doit être affiché ?" :label-for="'max' + index">
              <b-form-input :id="'max' + index" name="max" min="0" max="365" placeholder="Indiquez le nombre de jours avant lesquels un événement doit être affiché ?" type="number" v-model="parameters[index].max"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <b-btn type="submit" variant="primary" @click.prevent="edit">Modifier le paramètrage de la page agenda</b-btn>
      <router-link to="/parameters/list">
        <a class="btn btn-large btn-link">Revenir à la page précédente</a>
      </router-link>
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export default {
  data () {
    return {
      exist: true,
      parameters: [],
      types: []
    }
  },
  computed: {
    ...Vuex.mapGetters(['access_token', 'domain', 'schools', 'userId']),
    id () {
      return this.$route.params.id
    }
  },
  methods: {
    edit () {
      if (this.exist) {
        console.log('ca existe')
        for (let i = 0; i < this.parameters.length; i++) {
          let parameter = this.parameters[i]
          console.log(parameter)
          this.$http.post(this.domain + '/api/parameters/' + parameter.id + '/replace?access_token=' + this.access_token, parameter, { emulateJSON: true }).then((response) => {
            response.json().then((data) => {
              if (i === this.parameters.length - 1) {
                this.$root.$bvToast.toast('Les paramètres de la page agenda ont bien été modifié', {
                  title: 'Paramètres modifiés',
                  autoHideDelay: 3000,
                  append: false,
                  variant: 'success'
                })
                this.$router.push('/events')
              }
            })
          }, (response) => {

          })
        }
      } else {
        console.log('ca existe pas', this.parameters)
        for (let i = 0; i < this.parameters.length; i++) {
          let parameter = this.parameters[i]
          this.$http.post(this.domain + '/api/parameters?access_token=' + this.access_token, parameter, { emulateJSON: true }).then((response) => {
            response.json().then((data) => {
              if (i === this.parameters.length - 1) {
                this.$root.$bvToast.toast('Les paramètres de la page agenda ont bien été modifié', {
                  title: 'Paramètres modifiés',
                  autoHideDelay: 3000,
                  append: false,
                  variant: 'success'
                })
                this.$router.push('/events')
              }
            })
          }, (response) => {

          })
        }
      }
    },
    getParameters () {
      this.$http.get(this.domain + '/api/parameters?access_token=' + this.access_token + '&filter[where][schoolId]=' + this.id + '&filter[order]=name ASC', { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          for (let i = 0; i < data.length; i++) {
            this.parameters.push({
              id: data[i].id,
              limit: data[i].limit,
              max: data[i].max,
              name: data[i].name,
              schoolId: data[i].schoolId,
              typeId: data[i].typeId
            })
          }
          if (data.length === 0) {
            this.getTypes()
            this.exist = false
          }
        })
      }, (response) => {

      })
    },
    getTypes () {
      this.$http.get(this.domain + '/api/types?access_token=' + this.access_token + '&filter[order]=name ASC', { emulateJSON: true }).then((response) => {
        response.json().then((data) => {
          this.types = data
          for (let i = 0; i < data.length; i++) {
            this.parameters.push({
              limit: 0,
              max: 0,
              name: data[i].name,
              schoolId: this.id,
              typeId: data[i].id
            })
          }
        })
      }, (response) => {

      })
    }
  },
  mounted () {
    this.getParameters()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Parameters/Edit.vue